module.exports = "static/assets/4734f3fe917e80ae53b9f1f4e3d62147.mp3";